import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { doGetPromise } from '../../../../core/config/core.httpclient-utils';
import { GfTranslateService } from '../../../../core/services/core.translate.service';
import { UiService } from '../../../../core/services/core.ui.service';

import * as _ from 'lodash';

@Component({
  selector: 'ti-commits',
  template: require('./trackeritem.commits-tab.component.html')
})
export class CommitsTabComponent implements OnInit {
  @Input() trackeritem: any;
  @Input() tiMerge: any;
  
  commits: any[];

  constructor(
    private http: HttpClient, 
    private translateService: GfTranslateService, 
    private uiService: UiService
  ) {}

  ngOnInit(): void {
    this.init();
  }

  ngAfterViewInit(): void {
    if (this.tiMerge) {
      if (!this.tiMerge.selectedCommit) {
        this.tiMerge.selectedCommit = _.get(this.commits, '[0]', null);
      }
      if (this.tiMerge.selectedCommit) this.showCommitDiff(this.tiMerge.selectedCommit);
    }
  }

  showCommitDiff(commit: any): void {
    this.tiMerge.selectedCommit = commit;

    if (!_.get(commit, 'rel.diff', false)) {
      const url = `/api/scm/${_.get(commit, 'project.unixName', '')}/commit/${_.get(commit, 'commitHash', '')}?rel=diff`;
      doGetPromise(this.http, url)
        .then(
          (response: any) => {
            commit.meta = _.get(response, 'meta', {});
            commit.rel = {
              diff: _.get(response, 'rel.diff', [])
            };
          },
          (error: any) => {
            this.uiService.message.showWarning(this.translateService.translate("Sorry, could not fetch the requested commit diff"), "Commits");
            commit.rel = {
              diff: []
            };
          }
        );
    }
  }

  private init() {
    this.commits = _.sortBy(
      _.get(this.trackeritem, 'rel.commits', []),
      [
        (c: any) => c.commitDate ? new Date(c.commitDate).getTime() : 0,
        (c: any) => c.id || 0
      ]
    ).reverse();
  }
}
